<script setup lang="ts">
import { computed } from 'vue';
import AconnectShellLayout from '@/components/layouts/aconnect-shell-layout.vue';
import AconnectAccountMenu from '@/components/settings/account/aconnect-account-menu.vue';
import { useUserInfo } from '@/utils/swr';

const { data: userInfo } = useUserInfo();

const isSamlFederationActivated = computed(
  () => userInfo.value?.saml_federation_activated ?? false,
);
</script>

<template>
  <AconnectShellLayout subtitle="アカウント">
    <template #menu>
      <AconnectAccountMenu
        :is-saml-federation-activated="isSamlFederationActivated"
      />
    </template>
    <router-view />
  </AconnectShellLayout>
</template>
